import React from 'react'

const EventsButton = ({ activeTab, comData }) => {
    return (
        <div
            className={`tab-button ${activeTab === "events" ? "active" : ""
                }`}
            onClick={() => {
                window.open(
                    comData?.event_doc || comData?.event_url,
                    "_blank"
                );
            }}
            style={{
                backgroundColor: "white",
                opacity:
                    !comData?.event_doc && !comData?.event_url
                        ? 0.5
                        : 1,
                pointerEvents:
                    !comData?.event_doc && !comData?.event_url
                        ? "none"
                        : "auto",
            }}
        >
            <span className="reviews-icon-svg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="40"
                    height="40"
                    fill="none"
                    viewBox="0 0 433.633 433.633"
                    xmlSpace="preserve"
                >
                    <g>
                        <path
                            d="M388.749 47.038a38.674 38.674 0 0 0-2.66-.017h-33.437V18.286C352.653 6.792 341.681 0 330.187 0h-30.824c-11.494 0-19.853 6.792-19.853 18.286V47.02H154.122V18.286C154.122 6.792 145.763 0 134.269 0h-30.825C91.951 0 80.979 6.792 80.979 18.286V47.02H47.543C26.199 46.425 8.414 63.246 7.819 84.589c-.025.886-.019 1.774.017 2.66v301.975c0 22.988 16.718 44.408 39.706 44.408H386.09c22.988 0 39.706-21.42 39.706-44.408V87.249c.874-21.334-15.713-39.337-37.047-40.211zm-89.386-26.14h32.392v57.469h-32.392V20.898zm-195.918 0h29.78v57.469h-29.78V20.898zm301.453 368.326c0 11.494-7.314 23.51-18.808 23.51H47.543c-11.494 0-18.808-12.016-18.808-23.51v-222.04h376.163v222.04z"
                            fill="#414141"
                        />
                        <path
                            d="m158.824 309.812-9.404 52.245a10.453 10.453 0 0 0 1.049 6.556c2.675 5.113 8.989 7.09 14.102 4.415l47.02-24.555 47.02 24.555 4.702 1.045a9.925 9.925 0 0 0 6.269-2.09 10.45 10.45 0 0 0 4.18-9.927l-9.404-52.245 38.139-36.571a11.49 11.49 0 0 0 2.612-10.971 10.973 10.973 0 0 0-8.359-6.792l-52.245-7.837-23.51-47.543a10.444 10.444 0 0 0-4.849-4.849c-5.194-2.515-11.443-.344-13.959 4.849l-23.51 47.543-52.245 7.837a10.971 10.971 0 0 0-8.359 6.792 11.493 11.493 0 0 0 2.612 10.971l38.139 36.572z"
                            fill="#414141"
                        />
                    </g>
                </svg>
            </span>
            <span>Events</span>
        </div>
    )
}

export default EventsButton